import type { ExtendedAllergy } from '@seen/core/models/allergies'
import { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import type { JSX } from 'react'
import { ActivityComment } from '#src/components/activity/ActivityComment.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'

export function AllergyActivity({
  allergy,
}: {
  allergy: ExtendedAllergy
}): JSX.Element {
  const { data: comments = [] } = useSearch(
    CommentCommunication,
    CommentCommunication.searchQuery([allergy.reference])
  )

  return (
    <>
      {comments.map((comment) => (
        <ActivityComment key={comment.reference.reference} comment={comment} />
      ))}
    </>
  )
}
